import { View } from "@gaming/srvg-classes-core";

const svgStripedBackground = "";

const possibleTypes = [
    "stripedBackground",
];

export class SvgView extends View {
    type: string;

    constructor(options) {
        options = options || {};
        super(options);

        if (options.type){
            this.type=options.type;
        }else{

        }
    }

}